import { restApiLegacy } from '../../api/restApiSliceLegacy';
import { billingApiSlice } from './billingApiSlice';

type Dues = {
  totalDues: number;
  hasHierarchies: boolean;
};

type SubscriptionResponse = {
  result: Dues;
};

export function selectDues(subscription: SubscriptionResponse | undefined): Dues {
  return {
    totalDues: subscription?.result.totalDues ?? 0,
    hasHierarchies: subscription?.result.hasHierarchies ?? false,
  };
}

type ReactivateSubscriptionResponse = {
  result: string;
};

type GetCollectNowLinkResponse = {
  result: {
    collectNowLink: string;
  };
};

export const billingApiLegacySlice = restApiLegacy.injectEndpoints({
  endpoints: (builder) => ({
    getSubscription: builder.query<SubscriptionResponse, void>({
      query: () => `/v2/subscription`,
      providesTags: ['Subscription'],
    }),
    getCollectNowLink: builder.query<GetCollectNowLinkResponse, void>({
      query: () => `/v2/collect-now-link`,
    }),
    reactivateSubscription: builder.mutation<ReactivateSubscriptionResponse, { applyFreeTrialCoupon?: boolean }>({
      query: (body) => {
        return {
          url: `/v2/reactivate-subscription`,
          method: 'PATCH',
          body,
        };
      },

      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(billingApiSlice.util.invalidateTags(['Invoices']));
        } catch {
        // Ignore query fulfillment errors
      }
      },
      invalidatesTags: ['Subscription'],
    }),
  }),
});

export const { useGetSubscriptionQuery, useLazyGetCollectNowLinkQuery, useReactivateSubscriptionMutation } =
  billingApiLegacySlice;
